<template>
    <vue-date-picker
        v-bind="$attrs"
        :locale="locale"
        v-model="_value"
        first-day-of-week="mon"
        :input-class="computedInputClass"
        :placeholder="placeholder"
        :language="locale"
        :format="format"
        class="default-input form-input"
        color="#818CF8"
        :clearable="clearable"
    ></vue-date-picker>
</template>

<script>
import {VueDatePicker} from '@mathieustan/vue-datepicker';

export default {
    components: {
        VueDatePicker,
    },

    props: {
        inputClass: String,
        value: {},
        placeholder: {
            default: function() {return this.$t('date.date');},
        },
        format: {
            default: 'DD. MMMM YYYY'
        },
        clearable: {
            type: Boolean,
            default: true,
        },
    },

    computed: {
        _value: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            },
        },

        locale() {
            switch (this.$i18n.locale) {
                case 'en':
                    return {
                        lang: 'en',
                    };
                case 'de':
                    return {
                        lang: 'de',
                    };
                default:
                    throw new Error(`Language ${this.$i18n.locale} could not be found!`);
            }
        },

        computedInputClass() {
            return 'form-input rounded-md shadow-sm w-full '.concat(this.inputClass)
        },
    },
};
</script>
